import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {TelefoneComponent} from '../../shared/telefone/telefone.component';
import {AdvogadoRegistroComponent} from '../../shared/advogado-registro/advogado-registro.component';
import {AplicarRegraCampos} from '../../validators/aplicar-regra-campos';
import {CampoObrigatorio} from '../../validators/campo-obrigatorio';
import {
  MSG_OBG_ADESAO_WHATSAPP,
  MSG_OBG_INFORME_ANEXO_JUNTADA_DOCUMENTO,
  MSG_OBG_TURMA_RECURSAL
} from '../../../../../tools/Mensagens';
import {FILE_UPLOADER} from '../../../../../componentes/file-uploader/file-uploader.component';
import {ChangeDetectorRef} from '@angular/core';
import {CpeResponseDTO} from "../../../../../componentes/cpe-operador/dto/CpeResponseDTO";


@Component({
  selector: 'app-propria-parte-requerimento-geral',
  templateUrl: './propria-parte-requerimento-geral.component.html',
  styleUrls: ['./propria-parte-requerimento-geral.component.css']
})
export class PropriaParteRequerimentoGeralComponent implements OnInit, OnDestroy {

  @Input() formulario: FormGroup;
  @Input() somenteLeitura: boolean = false;
  @Input() dados: CpeResponseDTO;
  @ViewChild(TelefoneComponent, {static: false}) telefoneComponent: TelefoneComponent;
  @ViewChild(AdvogadoRegistroComponent, {static: false}) advogadoRegistroComponent: AdvogadoRegistroComponent;
  @ViewChild(FILE_UPLOADER, {static: false}) fileUploader: any;


  mostrarSessaoPossuiAdvogado = false;
  mostrarFileRequererJuntadaDocumento = false;
  mostrarTomarCienciaIntimidacao = false;
  mostrarIdDecisao = false;
  mostrarIdAcordao = false;

  idDecisaoMaxLength = '9';
  idAcordaoMaxLength = '9';

  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    if (!this.somenteLeitura) {
      const valorInicialParteInformacaoRequerente = this.dados && this.dados.informacaoRequerenteParte ? this.dados.informacaoRequerenteParte : '';
      const valorInicialPossuiAdvogado : string = this.dados && this.dados.possuiAdvogado == 'sim' ? 'sim' : 'não';
      const valorInicialRequererJuntadaDocumento = this.dados && this.dados.requererJuntadaDocumento ? this.dados.requererJuntadaDocumento : false;
      const valorInicialTomarCienciaIntimidacao = this.dados && this.dados.tomarCienciaIntimidacao ? this.dados.tomarCienciaIntimidacao : false;
      const valorInicialTipoDecisao = this.dados && this.dados.tipoDecisao ? this.dados.tipoDecisao : '';
      const valorInicialIdDecisao = this.dados && this.dados.idDecisao ? this.dados.idDecisao : '';
      const valorInicialIdAcordao = this.dados && this.dados.idAcordao ? this.dados.idAcordao : '';
      const valorInicialAdesaoWhatsapp = this.dados && this.dados.adesaoWhatsapp ? this.dados.adesaoWhatsapp : '';

      this.getFormulario().addControl('parteInformacaoRequerente', new FormControl(valorInicialParteInformacaoRequerente));
      this.getFormulario().addControl('possuiAdvogado', new FormControl(valorInicialPossuiAdvogado));
      this.getFormulario().addControl('requererJuntadaDocumento', new FormControl(valorInicialRequererJuntadaDocumento));
      this.getFormulario().addControl('arquivosRequererJuntadaDocumento', new FormArray([]));
      this.getFormulario().addControl('tomarCienciaIntimidacao', new FormControl(valorInicialTomarCienciaIntimidacao));
      this.getFormulario().addControl('tipoDecisao', new FormControl(valorInicialTipoDecisao));
      this.getFormulario().addControl('idDecisao', new FormControl(valorInicialIdDecisao));
      this.getFormulario().addControl('idAcordao', new FormControl(valorInicialIdAcordao));
      this.getFormulario().addControl('adesaoWhatsapp', new FormControl(valorInicialAdesaoWhatsapp));

      if(valorInicialPossuiAdvogado === 'sim'){
        this.setMostrarSessaoPossuiAdvogado(true);
      }else{
        this.setMostrarSessaoPossuiAdvogado(false);
      }

      if(valorInicialRequererJuntadaDocumento === true){
        this.definirMostrarFilerequererJuntadaDocumento(true);
      }else{
        this.definirMostrarFilerequererJuntadaDocumento(false);
      }

      if(valorInicialTomarCienciaIntimidacao === true){
        this.definirMostrarTomarCienciaIntimidacao(true);

        if(valorInicialTipoDecisao === 'decisão'){
          this.definirMostrarIDDecisao(true);
        }else{
          this.definirMostrarIDAcordao(true);
        }
      }else{
        this.definirMostrarTomarCienciaIntimidacao(false);
      }
    }
  }

  ngOnDestroy() {
    if (!this.somenteLeitura) {
      this.getFormularioGeral().removeControl('parteInformacaoRequerente');
    }
  }

  public validarFormulario() {
    this.validarTelefone();
    if (this.getFormulario().get('possuiAdvogado').value === 'sim') {
      this.validarRegistroAdvogado();
    }

    const campos = [];

    if (this.turmaRecursalNaoEstaSelecionado()) {
      campos.push({
        control: 'requererJuntadaDocumento',
        mensagem: MSG_OBG_TURMA_RECURSAL,
        regra: this.validarTurmaRecursal.bind(this)
      });
    }

    if (this.mostrarFileRequererJuntadaDocumento) {
      this.validarEAplicarAlertaUploadArquivo();
    }

    if (this.mostrarTomarCienciaIntimidacao) {
      if (this.tipoTomarCienciaDaIntimidacaoNaoEstaSelecionado()) {
        campos.push({
          control: 'tipoDecisao', mensagem: MSG_OBG_TURMA_RECURSAL, regra: this.validarTurmaRecursal.bind(this)
        });
      }

      if (this.mostrarIdDecisao) {
        campos.push({
          control: 'idDecisao', mensagem: MSG_OBG_TURMA_RECURSAL, regra: this.validarTurmaRecursal.bind(this)
        });
      }

      if (this.mostrarIdAcordao) {
        campos.push({
          control: 'idAcordao', mensagem: MSG_OBG_TURMA_RECURSAL, regra: this.validarTurmaRecursal.bind(this)
        });
      }
    }

    campos.push({
      control: 'adesaoWhatsapp', mensagem: MSG_OBG_ADESAO_WHATSAPP, regra: this.validarTurmaRecursal.bind(this)
    });

    if (campos.length > 0) {
      AplicarRegraCampos.aplicar(campos, this.getFormulario());
    }

  }

  private validarTurmaRecursal(value: any): boolean {
    return CampoObrigatorio.aplicarComStrFalse(value);
  }

  get arquivos(): FormArray {
    return this.getFormulario().get('arquivosRequererJuntadaDocumento') as FormArray; // Método para acessar o FormArray
  }


  private validarEAplicarAlertaUploadArquivo(): void {
    this.arquivos.clear();
    this.fileUploader.mapFilesBase64.forEach((value: any, key: any) => {
      this.arquivos.push(this.fb.group({
        nomeArquivo: key,
        conteudo: value
      }));
    });
    const valido = CampoObrigatorio.aplicarParaArray(this.arquivos.value);
    if (!valido) {
      this.getFormulario().setErrors({ invalid: true });
      this.getFormulario().markAsTouched();
      alert(MSG_OBG_INFORME_ANEXO_JUNTADA_DOCUMENTO);
    }
  }


  private validarTelefone() {
    if (this.telefoneComponent) {
      this.telefoneComponent.validarFormulario();
    }
  }

  private validarRegistroAdvogado() {
    if (this.advogadoRegistroComponent) {
      this.advogadoRegistroComponent.validarFormulario();
    }
  }

  private turmaRecursalNaoEstaSelecionado(): boolean {
    return (this.getFormulario().get('requererJuntadaDocumento').value === false
        || this.getFormulario().get('requererJuntadaDocumento').value === '')
      && (this.getFormulario().get('tomarCienciaIntimidacao').value === false
        || this.getFormulario().get('tomarCienciaIntimidacao').value === '');
  }

  private tipoTomarCienciaDaIntimidacaoNaoEstaSelecionado(): boolean {
    return (this.getFormulario().get('tipoDecisao').value == null
      || this.getFormulario().get('tipoDecisao').value === '');
  }

  protected getFormulario() {
    let formParteInformacaoRequerente = this.formulario.get('requerimentoGeral').get('parteInformacaoRequerente') as FormGroup;
    if (!formParteInformacaoRequerente) {
      formParteInformacaoRequerente = new FormGroup({});
      this.getFormularioGeral().setControl('parteInformacaoRequerente', formParteInformacaoRequerente);
    }

    return formParteInformacaoRequerente;
  }

  protected setMostrarSessaoPossuiAdvogado(mostrar: boolean) {
    this.mostrarSessaoPossuiAdvogado = mostrar;
    this.cdr.detectChanges();
  }

  protected definirMostrarFilerequererJuntadaDocumento(check: boolean) {
    this.mostrarFileRequererJuntadaDocumento = check;
    this.cdr.detectChanges();
  }

  protected definirMostrarTomarCienciaIntimidacao(check: boolean) {
    this.mostrarTomarCienciaIntimidacao = check;
    this.cdr.detectChanges();
  }

  protected definirMostrarIDDecisao(check: boolean) {
    this.mostrarIdDecisao = check;
    this.mostrarIdAcordao = false;
    this.getFormulario().get('idAcordao').setValue('');
    this.cdr.detectChanges();
  }

  protected definirMostrarIDAcordao(check: boolean) {
    this.mostrarIdAcordao = check;
    this.mostrarIdDecisao = false;
    this.getFormulario().get('idDecisao').setValue('');
    this.cdr.detectChanges();
  }

  private getFormularioGeral() {
    return this.formulario.get('requerimentoGeral') as FormGroup;
  }
}
